var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2899 11.9999L14.8299 8.45995C15.0162 8.27259 15.1207 8.01913 15.1207 7.75495C15.1207 7.49076 15.0162 7.23731 14.8299 7.04995C14.737 6.95622 14.6264 6.88183 14.5045 6.83106C14.3827 6.78029 14.252 6.75415 14.1199 6.75415C13.9879 6.75415 13.8572 6.78029 13.7354 6.83106C13.6135 6.88183 13.5029 6.95622 13.4099 7.04995L9.16994 11.2899C9.07622 11.3829 9.00182 11.4935 8.95105 11.6154C8.90028 11.7372 8.87415 11.8679 8.87415 11.9999C8.87415 12.132 8.90028 12.2627 8.95105 12.3845C9.00182 12.5064 9.07622 12.617 9.16994 12.7099L13.4099 16.9999C13.5034 17.0926 13.6142 17.166 13.736 17.2157C13.8579 17.2655 13.9883 17.2907 14.1199 17.2899C14.2516 17.2907 14.382 17.2655 14.5038 17.2157C14.6257 17.166 14.7365 17.0926 14.8299 16.9999C15.0162 16.8126 15.1207 16.5591 15.1207 16.2949C15.1207 16.0308 15.0162 15.7773 14.8299 15.5899L11.2899 11.9999Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.9148c7d9a5ee3cd21bf4025cc52c6d1d.svg";
export { ForwardRef as ReactComponent };